import React, { } from "react";
import useIntersectionObserver from "./home-animation";
export default function HomeCommunity() {
    const [sectionRef1, isVisible1] = useIntersectionObserver({ threshold: 0.1 });
    return (
        <div className="home-community">
            <div className="outer-container">
            <div className="home-community-overlay"></div>
            <div className={`home-community-inner home-employe-div ${isVisible1 ? 'animate__fadeIn' : ''}`} style={{ animationDuration: '1.25s' }}  ref={sectionRef1}>
                <div className="connecting-head">Join our community of talented professionals by exploring exciting career opportunities!</div>
                <p className="main-para text-white connecting-para">Discover fulfilling roles that match your skills and aspirations. Start your journey towards a rewarding career with us.</p>
                {/* <button type="button" className="home-page-btn1 mx-auto">Explore Opportunities</button> */}
            </div>
        </div>
        </div>
    );
}
